<template>
  <InputSelect
    title=""
    name="language-select"
    isRequired
    class="mb-0"
    valueField="id"
    textField="display_name"
    :options="languageList"
    v-model="selectLanguage"
    @onDataChange="onChange($event)"
    v-show="showInput"
  />
</template>

<script>
export default {
  props: {
    value: {
      required: false,
    },
  },
  data() {
    return {
      languageList: [],
      selectLanguage: this.value || this.$store.state.currentLanguage,
    };
  },
  created() {
    console.log(this.value);
    this.getDisplayLang();
  },
  computed: {
    showInput() {
      return this.languageList.length > 1;
    },
  },
  methods: {
    async getDisplayLang() {
      const resp = await this.$store.dispatch("getLanguageList");
      this.selectLanguage = this.value
        ? this.value
        : this.$store.state.currentLanguage || 1;
      this.languageList = resp.data.detail.filter((el) => el.active == 1);
    },
    onChange(val) {
      this.$store.commit("setCurrentLanguage", val);
      this.$emit("changeLang", val);
    },
    setValue(val) {
      this.selectLanguage = val;
      this.$store.commit("setCurrentLanguage", val);
      this.$emit("changeLang", val);
    },
  },
};
</script>

<style></style>
